import React from 'react';

interface WebsiteLogoProps {
  imageSrc: string;
}

const WebsiteLogo: React.FC<WebsiteLogoProps> = ({ imageSrc }) => {
  return (
    <div className="container w-full mx-auto flex items-center justify-center mb-6 pb-10 md:mb-0">
      <img src={imageSrc} alt="logo" className="max-w-[500px] h-23 w-auto" />
    </div>
  );
};

export default WebsiteLogo;
